import image from '../images/a347ce99-9901-4361-953e-f3306909469c.JPG';
import nuanceColor from '../images/nuancecolor.png'
import { Link } from 'react-router-dom';
import React from "react";
import FaqComponent from "react-faq-component";

function Faq() {
    const data = {
        rows: [
            {
                title: "Quel est le thème couleur du mariage ?",
                content: (
                    <>
                        Le thème couleur du mariage est une touche de pêche, terracotta ou bleu céladon.
                        Voici une illustration pour vous inspirer :
                        <br />
                        <img src={nuanceColor} alt="Nuancier" style={{ maxWidth: '50%', marginTop: '10px' }} />
                        <br />
                        N’hésitez pas à incorporer ces couleurs dans votre tenue pour être en harmonie avec l’ambiance du mariage ! 😊
                    </>
                ),
            },
            {
                title: "Ou se trouve le lieu du mariage ?",
                content: (
                    <>
                        Le mariage aura lieu en Corse, au Domaine de Salliccia.
                        <br/>
                        Vous pouvez retrouver la localisation exacte ainsi que des suggestions de logements sur cette carte : <Link to="/map">Carte et hébergements</Link>
                        <br/>
                        Si vous avez besoin d'informations supplémentaires sur l'accès au lieu ou les options d'hébergement, n'hésitez pas à me demander ! 😊
                    </>
                ),
                    
            },
            {
                title: "Comment confirmer ma présence au mariage ? ",
                content: (
                    <>
                        Pour confirmer votre présence au mariage, il vous suffit de remplir le formulaire de RSVP en ligne en suivant ce lien : <Link to="/wedding-rsvp">Confirmer ma présence</Link>
                        <br />
                        Merci de répondre dès que possible afin que les mariés puissent organiser au mieux cette belle journée ! 😊✨
                    </>
                ),
            }
        ],
    };

    const styles = {
        bgColor: null
    }

    return (
        <div>
            <div
            className="hero"
            style={{ backgroundImage: `url(${image})`, height: "250px" }}
            >
                <div className="hero-inner">
                    <div className="inner">
                    <div className="hero-line-one">
                        Foire aux questions
                    </div>
                    </div>
                    <Link className="more-arrow" to="#content">
                    <i className="fa fa-chevron-down"></i>
                    <span>Scroll Down</span>
                    </Link>
                </div>
            </div>
            <div className="wrap full-wrap">
                <div className="main-wrap">
                    <section className="main" style={{paddingLeft: '10px'}}>
                    <FaqComponent
                        data={data}
                        styles={styles}
                    />
                    </section>
                </div>
            </div>
        </div>
    )
}

export default Faq;